import Switcher from "@components/switcher/Switcher";
import React from "react";
import PrimeEuropeOrderFlowDetails from "./PrimeEuropeOrderFlowDetails";
import PrimeEuropeUserDetails from "./PrimeEuropeUserDetails";
import PrimeLogs from "./PrimeLogs";

interface PrimeDetailsEuropeTabsProps {
  instanceId: string;
  width?: string;
  onEventChange?: (instanceId: string, newEventId: number) => void;
}

const PrimeDetailsEuropeTabs: React.FC<PrimeDetailsEuropeTabsProps> = ({
  instanceId,
  onEventChange,
}) => {
  const tabs = [
    {
      label: "TRADE",
      component: (
        <PrimeEuropeOrderFlowDetails
          instanceId={instanceId}
          onEventChange={onEventChange}
        />
      ),
    },
    {
      label: "USER",
      component: <PrimeEuropeUserDetails instanceId={instanceId} />,
    },
    {
      label: "LOGS",
      component: (
        <PrimeLogs
          instanceId={instanceId}
          endPoint="/adminPanel/getEURCallbackLogs"
          sendCallbackEndPoint="/adminPanel/sendEURCallbackForLog"
        />
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-[12px]">
      <Switcher tabs={tabs} />
    </div>
  );
};

export default PrimeDetailsEuropeTabs;
